export function parseRawInput(raw, format) {
    raw = raw.trim().toLowerCase();
    if (!raw) return null;

    let ampm = null;

    if (format === 'ampm') {
        if (raw.endsWith('am')) { ampm = 'am'; raw = raw.replace(/am$/, ''); }
        if (raw.endsWith('pm')) { ampm = 'pm'; raw = raw.replace(/pm$/, ''); }
    }

    const [hStr, mStr] = raw.split(':');
    let h = parseInt(hStr || '0', 10);
    let m = parseInt(mStr || '0', 10);

    if (isNaN(h)) h = 0;
    if (isNaN(m)) m = 0;

    if (format === 'ampm') {
        if (ampm === 'pm' && h < 12) h += 12;
        if (ampm === 'am' && h === 12) h = 0;
    }

    return clampTime(h, m);
}

export function clampTime(h, m) {
    h = Math.max(0, Math.min(23, h));
    m = Math.max(0, Math.min(59, m));
    return `${pad(h)}:${pad(m)}`;
}

export function pad(v) {
    return String(v).padStart(2, '0');
}

export function toDisplay(time24) {
    if (!time24) return '';

    const [hStr, mStr] = time24.split(':');
    let h = Number(hStr);

    h = h % 12;
    if (h === 0) h = 12;

    return `${h}:${mStr}`;
}

export function applyAMPM(h, ampm) {
    if (ampm === 'pm' && h < 12) return h + 12;
    if (ampm === 'am' && h === 12) return 0;
    return h;
}

export function clampBetween(time, min, max) {
    const toMin = t => {
        const [h, m] = t.split(':').map(Number);
        return h * 60 + m;
    };

    let v = toMin(time);
    if (min) v = Math.max(v, toMin(min));
    if (max) v = Math.min(v, toMin(max));

    const h = Math.floor(v / 60);
    const m = v % 60;
    return `${pad(h)}:${pad(m)}`;
}

export function nextHour(h, format, direction) {
    h = Number(h || 0);
    h += direction;

    if (format === 'ampm') {
        if (h > 12) h = 1;
        if (h < 1) h = 12;
    } else {
        if (h > 23) h = 0;
        if (h < 0) h = 23;
    }
    return h;
}

export function nextMinute(m, direction) {
    m = Number(m || 0);
    m += direction;

    if (m > 59) m = 0;
    if (m < 0) m = 59;
    return m;
}

export function getFocusableElements() {
    return Array.from(
        document.querySelectorAll(`
                a[href],
                button:not([disabled]),
                input:not([disabled]),
                select:not([disabled]),
                textarea:not([disabled]),
                [tabindex]:not([tabindex="-1"])
            `)
    ).filter(el => el.offsetParent !== null); // visible only
}

export function focusNextFocusable(currentEl) {
    const list = getFocusableElements();
    const index = list.indexOf(currentEl);
    if (index === -1) return;

    const next = list[index + 1];
    if (next) next.focus();
}

export function focusPrevFocusable(currentEl) {
    const els = getFocusableElements();
    const i = els.indexOf(currentEl);
    if (i > 0 && els[i - 1]) els[i - 1].focus();
}
